import { combineReducers } from '@reduxjs/toolkit';
import dashboardBackgroundImgSlice from '@store/reducers/dashboardBackgroundImgSlice';
import dashboardRealTimeValueSlice from '@store/reducers/dashboardRealTimeValueSlice';
import permissionSlice from '@store/reducers/permissionSlice';
import preferencesSlice from '@store/reducers/preferencesSlice';
import treeGraphSlice from '@store/reducers/treeGraphSlice';
import userSlice from '@store/reducers/userSlice';

const rootReducer = combineReducers({
  userSlice,
  permissionSlice,
  treeGraphSlice,
  dashboardBackgroundImgSlice,
  dashboardRealTimeValueSlice,
  preferencesSlice,
});

export type IRootState = ReturnType<typeof rootReducer>;
export default rootReducer;
